






























import { Component, Prop, Vue } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";

@Component
export default class USectionBox extends Vue {
  // Props

  @Prop({ default: "" })
  public title!: TranslateResult | string;

  @Prop({ default: "" })
  public description!: TranslateResult | string;

  // Computed

  public get hasTitle() {
    return !!(this.$scopedSlots?.title || this.title.length);
  }

  public get hasDescription() {
    return !!(this.$scopedSlots?.description || this.description.length);
  }

  public get hasFooter() {
    return !!this.$scopedSlots?.footer;
  }
}
